import {AuthModel} from './_models'
import axios from 'axios';

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}
// export function setupAxios(axios: any) {
//   axios.defaults.headers.Accept = 'application/json'

//   axios.interceptors.request.use(
//     (config: {headers: {Authorization: string; x_api_key:string}}) => {
//       // config.headers.x_api_key = `123-456-789`
//       const auth = getAuth()
//       if (auth && auth.api_token) {
//         config.headers.Authorization = `Bearer ${auth.api_token}`
//       }

//       return config
//     },
//     (err: any) => Promise.reject(err)
//   )
// }
export function setupAxios(axiosInstance) {
  axiosInstance.defaults.headers.Accept = 'application/json';

  axiosInstance.interceptors.request.use(
    (config) => {
      // Setting the x-api-key header
      // config.headers['x-api-key'] = 'Bearer 123-456-789';

      // Setting the Authorization header if the auth token is available
      const auth = getAuth();
      if (auth && auth.api_token) {
        config.headers.Authorization = `Bearer ${auth.api_token}`;
      }

      return config;
    },
    (err) => Promise.reject(err)
  );
}



export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
